import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  initials: 'MG',
  name: 'Martín G.',
  city: 'CABA',
  text: 'Apliqué el guion de la primera consulta y capté mi primer 3 ambientes en exclusiva. No lo podía creer.'
}, {
  initials: 'LS',
  name: 'Lucía S.',
  city: 'Córdoba',
  text: 'Estaba paralizada sin saber por dónde empezar. El plan de 90 días me dio el paso a paso exacto.'
}, {
  initials: 'FR',
  name: 'Facundo R.',
  city: 'Rosario',
  text: 'La calculadora de comisiones me abrió la cabeza. Ahora sé exactamente cuántas tasaciones necesito por mes.'
}];
export function EarlyTestimonials() {
  return <section className="py-16 bg-white px-6 lg:px-8" data-id="element-59">
      <div className="max-w-6xl mx-auto" data-id="element-60">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-61">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-lighter rounded-2xl p-6 border border-brand-light" data-id="element-62">
              <div className="flex items-center gap-4 mb-4" data-id="element-63">
                <div className="w-12 h-12 rounded-full bg-brand-accent text-white flex items-center justify-center font-bold text-lg" data-id="element-64">
                  {t.initials}
                </div>
                <div data-id="element-65">
                  <h4 className="font-bold text-brand-navy" data-id="element-66">{t.name}</h4>
                  <p className="text-sm text-brand-navy/60" data-id="element-67">{t.city}</p>
                </div>
              </div>
              <p className="text-brand-navy/80 italic" data-id="element-68">"{t.text}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}